import React from 'react';
export function TagList(props) {
  var highlight = tag =>  props.activeFilters && props.activeFilters.includes(tag);
  return (<ul className={(props.className?props.className:"") + " tagList"}>
    {props.tags.map(tag => <li key={tag} className={highlight(tag)?"highlight":""}>{tag + ""}</li>)}</ul>);
}
